"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderCommission = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
class OrderCommissionAppliedCommission {
    campaignId;
    percentage;
    valueInCommissionCurrency;
    exchangeRate;
    valueInPricingCurrency;
}
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OrderCommissionAppliedCommission.prototype, "campaignId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommissionAppliedCommission.prototype, "percentage", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommissionAppliedCommission.prototype, "valueInCommissionCurrency", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommissionAppliedCommission.prototype, "exchangeRate", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommissionAppliedCommission.prototype, "valueInPricingCurrency", void 0);
class OrderCommissionBaseCommission {
    percentage;
    valueInCommissionCurrency;
    exchangeRate;
    valueInPricingCurrency;
}
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommissionBaseCommission.prototype, "percentage", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommissionBaseCommission.prototype, "valueInCommissionCurrency", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommissionBaseCommission.prototype, "exchangeRate", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommissionBaseCommission.prototype, "valueInPricingCurrency", void 0);
let OrderCommission = class OrderCommission {
    percentage;
    valueInPricingCurrency;
    commissionCurrency;
    commissionCurrencyExchangeRate;
    valueInCommissionCurrency;
    payoutRequestId;
    settlementId;
    appliedCommissions = [];
    baseCommission;
};
exports.OrderCommission = OrderCommission;
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommission.prototype, "percentage", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommission.prototype, "valueInPricingCurrency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommission.prototype, "commissionCurrency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommission.prototype, "commissionCurrencyExchangeRate", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCommission.prototype, "valueInCommissionCurrency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OrderCommission.prototype, "payoutRequestId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OrderCommission.prototype, "settlementId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderCommissionAppliedCommission),
    __metadata("design:type", Array)
], OrderCommission.prototype, "appliedCommissions", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderCommissionBaseCommission),
    __metadata("design:type", OrderCommissionBaseCommission)
], OrderCommission.prototype, "baseCommission", void 0);
exports.OrderCommission = OrderCommission = __decorate([
    (0, typeorm_1.Entity)("orderCommission"),
    (0, type_graphql_1.ObjectType)("OrderCommission")
], OrderCommission);
//# sourceMappingURL=OrderCommission.js.map